import { Divider, Modal } from "antd";
import axios from "axios";
import "./style.css";
import { FiAlertCircle, FiX } from "react-icons/fi";

import { useEffect, useState } from "react";

import { api } from "../../../api/url";
import Button from "../../Button";
import { number_3_3 } from "../../../utilities";

const ConfirmVisitComponent = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [penalty, setPenalty] = useState({
    admissionAmount: "",
    cashAmount: "",
    penaltyAmount: "",
    penaltyId: "",
    penaltyValue: "",
    returnAmount: "",
  });

  const [httpStatus, setHttpStatus] = useState();

  const handleOk = () => {
    props.setOpen(false);
  };
  const handleCancel = () => {
    props.setOpen(false);
  };

  const CancelVisit = async () => {
    await axios({
      method: "post",
      url:
        api +
        "appointment/admission/return/" +
        props?.curItem?.admissionId +
        "/" +
        localStorage.getItem("user"),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        props.setClose();
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const PaymentInfo = async () => {
    await axios({
      method: "post",
      url:
        api +
        "appointment/admission/getreturnpenalty/" +
        props?.curItem?.admissionId,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        setPenalty(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const CheckCancel = async () => {
    setLoading(true);
    await axios({
      method: "post",
      url:
        api +
        "appointment/admission/returnvalidattion/" +
        props?.curItem?.admissionId +
        "/" +
        localStorage.getItem("user"),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        setHttpStatus(res.data.httpStatus);
        if (res?.data?.data?.length > 0) {
          props.setStep(1);
          setData(res?.data?.data);
        } else {
          PaymentInfo();
          props.setStep(2);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  return (
    <Modal
      open={props.open}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
    >
      <div className="visit-modal-confirm">
        <h4>لغو پذیرش</h4>
        {props.step === 0 && (
          <>
            <div className="visit-modal-confirm-content">
              <div className="row">
                <div className="col-lg-12 col-12 ">
                  شما قصد دارید نوبت خودرا با دکتر{" "}
                  <span className="visit-modal-doctorname">
                    {props?.curItem?.attenderFullName}
                  </span>{" "}
                  لغو کنید. آیا اطمینان دارید؟
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-12 cancel-verify-modal ">
                  <FiAlertCircle />
                  <a
                    target="_blank"
                    href={"/cancelrules/" + props?.curItem.companyId}
                  >
                    مشاهده قوانین لغو نوبت
                  </a>
                </div>
              </div>
            </div>
            <Button
              isSubmitting={loading}
              onClick={() => CheckCancel()}
              className="modal-phonenumber-container-button"
            >
              بررسی برای لغو
            </Button>
          </>
        )}

        {props.step === 1 && (
          <>
            <div className="visit-modal-confirm-content">
              <div className="row">
                <p>
                  متاسفانه برای لغو نوبت مشکلات زیر وجود دارد.ابتدا آن‌هارا
                  بررسی کنید و سپس مجددا درخواست دهید.
                </p>
              </div>
              {data.map((item) => (
                <p className="cancel-reserve-errors">
                  <FiX />
                  {item}
                </p>
              ))}
            </div>
            <Button
              isSubmitting={loading}
              onClick={() => props.setClose()}
              className="modal-phonenumber-container-button"
            >
              بستن
            </Button>
          </>
        )}

        {props.step === 2 && (
          <>
            <div className="visit-modal-confirm-content">
              <div className="row">
                <div className="col-lg-6  col-6">مبلغ پرداختی:</div>
                <div className="col-lg-6 col-6 visit-modal-left">
                  {number_3_3(penalty?.admissionAmount)} ریال
                </div>
              </div>
              {/* <div className="row">
                <div className="col-lg-6  col-6">خدمات درمانی:</div>
                <div className="col-lg-6 col-6 visit-modal-left">
                  {number_3_3(penalty?.penaltyAmount)} ریال
                </div>
              </div> */}
              <div className="row">
                <div className="col-lg-6  col-6 error-color">
                  مبلغ کسر شده: ({penalty.penaltyValue}٪ جریمه کنسلی)
                </div>
                <div className="col-lg-6 col-6 visit-modal-left error-color">
                  {number_3_3(penalty?.penaltyAmount)} ریال
                </div>
              </div>
              <Divider />

              <div className="row">
                <div className="col-lg-6  col-6">مبلغ بازگشتی به حساب شما:</div>
                <div className="col-lg-6 col-6 visit-modal-left">
                  {number_3_3(penalty?.returnAmount)} ریال
                </div>
              </div>
            </div>
            <Button
              isSubmitting={loading}
              onClick={() => CancelVisit()}
              className="modal-phonenumber-container-button"
            >
              تایید و لغو نوبت
            </Button>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmVisitComponent;
